import "../../styles/legionPartnerStyle.css";

export default function LegionPartner() {
    return (
        <>
            <div id={"legionPartner"} className={'LegionPartner LegionPartnerShipBackground'}>
                <div className={'LegionPartnerBackColor'}>
                    <div className={'PartnerHead text-center mt-2 p-3'}>
                        გახდი ლეგიონის პარტნიორი
                    </div>
                    <div className={'p-2 font-monospace'}>
                        <p className={'text-center'}>
                            ლეგიონი არის სახალხო პროექტი და ჩვენი ყველა აქტივობა იყო, არის და იქნება უფასო.
                        </p>
                        <p className={'text-center'}>
                            ვის შეუძლია გახდეს ლეგიონის პარტნიროი?
                        </p>
                        <p className={'text-center'}>
                            როგორც ფიზიკურ პირს, ასევე კომერციულ ფირმებს - გახდი ლეგიონის პარტნიორი.
                        </p>
                        <p className={'text-center'}>
                            საპარტნიორო დახმარებას ათასობით ახალგაზრდის მომავლის შეცვლა შეუძლია უკეთესობისკენ საქართველოს
                            მთელი მასშტაბით! ძალა ერთობაშია!L
                        </p>
                        <p className={'text-center'}>
                            ააიპ გენერალ მაზნიაშვილის სახელობის ახალგაზრდული ლეგიონი
                        </p>
                        <p className={'text-center'}>
                            თიბის ბანკი: TBCBGE22 ანგარიშის ნომერი: GE92TB7036636080100003
                        </p>
                        <p className={'text-center'}>
                            საქართველოს ბანკი: BAGAGE22 ანგარიშის ნომერი: GE14BG0000000533902429
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}